webpackJsonp([29],{

/***/ 1518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__ = __webpack_require__(1824);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "context", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19d816d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__ = __webpack_require__(2119);
function injectStyle (ssrContext) {
  __webpack_require__(2117)
}
var normalizeComponent = __webpack_require__(948)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19d816d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19d816d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    props: {
        showDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        maxWidth: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        showDialog: function showDialog(newVal, oldVal) {}
    },
    computed: {
        style: function style() {
            return 'max-width: ' + this.maxWidth;
        }
    }
});

/***/ }),

/***/ 1534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1533);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f95abfa4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1540);
function injectStyle (ssrContext) {
  __webpack_require__(1538)
}
var normalizeComponent = __webpack_require__(948)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f95abfa4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f95abfa4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1538:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1539);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1498)("5ce10168", content, true, {});

/***/ }),

/***/ 1539:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1497)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-f95abfa4]{position:fixed;z-index:10;left:0;top:0;width:100%;height:100%;overflow:auto;display:block;background-color:rgba(0,0,0,.4)}.flex-container[data-v-f95abfa4]{height:100%;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.modal-content[data-v-f95abfa4]{background-color:#fefefe;border:unset;width:auto;z-index:1000;border-radius:5px;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.2);box-shadow:0 4px 10px rgba(0,0,0,.2)}.modal-header[data-v-f95abfa4]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:16px;font-style:normal;font-weight:600;color:#fff}.close[data-v-f95abfa4]{color:#fff;float:right;font-size:28px;font-weight:700}.close[data-v-f95abfa4]:focus,.close[data-v-f95abfa4]:hover{color:#000;text-decoration:none;cursor:pointer}.widthClass[data-v-f95abfa4]{max-width:30%}#mdiv[data-v-f95abfa4]{width:25px;height:25px;cursor:pointer}.mdiv[data-v-f95abfa4]{height:25px;width:2px;margin-left:12px;background-color:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg);Z-index:1}.md[data-v-f95abfa4]{height:25px;width:2px;background-color:#fff;-webkit-transform:rotate(90deg);transform:rotate(90deg);Z-index:2}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Modal.vue"],"names":[],"mappings":"AACA,wBACI,eAAgB,AAChB,WAAY,AACZ,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,cAAe,AACf,cAAe,AACf,+BAAkC,CACrC,AACD,iCACI,YAAa,AACb,UAAW,AACX,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,gCACI,yBAA0B,AAC1B,aAAc,AACd,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,6CAAiD,AACzC,oCAAyC,CACpD,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,WAAa,AACb,YAAa,AACb,eAAgB,AAChB,eAAkB,CACrB,AACD,4DAEI,WAAa,AACb,qBAAsB,AACtB,cAAgB,CACnB,AACD,6BACI,aAAe,CAClB,AAKD,uBACE,WAAY,AACZ,YAAa,AACb,cAAgB,CACjB,AACD,uBACE,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,qBACE,YAAa,AACb,UAAW,AACX,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ","file":"Modal.vue","sourcesContent":["\n.modal[data-v-f95abfa4] {\n    position: fixed;\n    z-index: 10;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    display: block;\n    background-color: rgba(0,0,0,0.4);\n}\n.flex-container[data-v-f95abfa4] {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.modal-content[data-v-f95abfa4] {\n    background-color: #fefefe;\n    border: unset;\n    width: auto;\n    z-index: 1000;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n            box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n}\n.modal-header[data-v-f95abfa4] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.close[data-v-f95abfa4] {\n    color: white;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n.close[data-v-f95abfa4]:hover,\n.close[data-v-f95abfa4]:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n.widthClass[data-v-f95abfa4] {\n    max-width: 30%;\n}\n.modal-slot[data-v-f95abfa4] {\n    /* margin-right: 10px;\n    margin-left: 10px; */\n}\n#mdiv[data-v-f95abfa4] {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n.mdiv[data-v-f95abfa4] {\n  height: 25px;\n  width: 2px;\n  margin-left: 12px;\n  background-color: white;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  Z-index: 1;\n}\n.md[data-v-f95abfa4] {\n  height: 25px;\n  width: 2px;\n  background-color: white;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  Z-index: 2;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal flex-container"},[_c('div',{staticClass:"modal-content vertical",style:(_vm.style)},[_c('div',{staticClass:"modal-header"},[(_vm.title != undefined)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title != null ? _vm.title : '')+" ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"mdiv"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-slot"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdiv"},[_c('div',{staticClass:"md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __vue_component__; });
/* unused harmony export install */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'VueToggles',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    checkedText: {
      type: String,
      default: null,
    },
    uncheckedText: {
      type: String,
      default: null,
    },
    width: {
      type: [Number, String],
      default: 75,
    },
    height: {
      type: [Number, String],
      default: 25,
    },
    uncheckedBg: {
      type: String,
      default: '#939393',
    },
    checkedBg: {
      type: String,
      default: '#5850ec',
    },
    dotColor: {
      type: String,
      default: '#fff',
    },
    fontSize: {
      type: [Number, String],
      default: '12',
    },
    checkedColor: {
      type: String,
      default: '#fff',
    },
    uncheckedColor: {
      type: String,
      default: '#fff',
    },
    fontWeight: {
      type: [Number, String],
      default: 'normal',
    },
  },
  computed: {
    bgStyle: function bgStyle() {
      var styles = {
        width: ((this.width) + "px"),
        height: ((this.height) + "px"),
        background: this.value ? this.checkedBg : this.uncheckedBg,
        opacity: this.disabled ? '0.5' : '1',
        cursor: !this.disabled ? 'pointer' : 'not-allowed',
      };

      return styles;
    },
    dotStyle: function dotStyle() {
      var styles = {
        background: this.dotColor,
        width: ((this.height - 8) + "px"),
        height: ((this.height - 8) + "px"),
        'min-width': ((this.height - 8) + "px"),
        'min-height': ((this.height - 8) + "px"),
        'margin-left': this.value ? ((this.width - (this.height - 3)) + "px") : '5px',
      };

      if ((!this.value && this.reverse) || (this.value && !this.reverse)) {
        styles.marginLeft = (this.width - (this.height - 3)) + "px";
      } else if ((this.value && this.reverse) || (!this.value && !this.reverse)) {
        styles.marginLeft = '5px';
      }

      return styles;
    },
    textStyle: function textStyle() {
      var styles = {
        'font-weight': this.fontWeight,
        'font-size': ((this.fontSize) + "px"),
        color: this.value && !this.disabled ? this.checkedColor : this.uncheckedColor,
        right: this.value ? ((this.height - 3) + "px") : 'auto',
        left: this.value ? 'auto' : ((this.height - 3) + "px"),
      };

      if (!this.value && this.reverse) {
        styles.right = (this.height - 3) + "px";
        styles.left = 'auto';
      } else if (this.value && this.reverse) {
        styles.left = (this.height - 3) + "px";
        styles.right = 'auto';
      }

      return styles;
    },
  },
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    var options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

var isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return function (id, style) { return addStyle(id, style); };
}
var HEAD;
var styles = {};
function addStyle(id, css) {
    var group = isOldIE ? css.media || 'default' : id;
    var style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        var code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                { style.element.setAttribute('media', css.media); }
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            var index = style.ids.size - 1;
            var textNode = document.createTextNode(code);
            var nodes = style.element.childNodes;
            if (nodes[index])
                { style.element.removeChild(nodes[index]); }
            if (nodes.length)
                { style.element.insertBefore(textNode, nodes[index]); }
            else
                { style.element.appendChild(textNode); }
        }
    }
}

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "span",
    {
      staticClass: "vue-toggles",
      style: _vm.bgStyle,
      attrs: {
        role: "switch",
        tabindex: "0",
        "aria-checked": _vm.value ? "true" : "false",
        "aria-readonly": _vm.disabled ? "true" : "false"
      },
      on: {
        click: function($event) {
          !_vm.disabled ? _vm.$emit("click", _vm.value) : null;
        },
        keyup: [
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault();
            !_vm.disabled ? _vm.$emit("click", _vm.value) : null;
          },
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
            ) {
              return null
            }
            $event.preventDefault();
            !_vm.disabled ? _vm.$emit("click", _vm.value) : null;
          }
        ]
      }
    },
    [
      _c(
        "span",
        {
          staticClass: "dot",
          style: _vm.dotStyle,
          attrs: { "aria-hidden": "true" }
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkedText && _vm.value,
                  expression: "checkedText && value"
                }
              ],
              staticClass: "text",
              style: _vm.textStyle
            },
            [_vm._v("\n      " + _vm._s(_vm.checkedText) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.uncheckedText && !_vm.value,
                  expression: "uncheckedText && !value"
                }
              ],
              staticClass: "text",
              style: _vm.textStyle
            },
            [_vm._v("\n      " + _vm._s(_vm.uncheckedText) + "\n    ")]
          )
        ]
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = function (inject) {
    if (!inject) { return }
    inject("data-v-ce3b9412_0", { source: "\n.vue-toggles {\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 9999px;\r\n  overflow: hidden;\r\n  transition: background-color ease 0.2s, width ease 0.2s, height ease 0.2s;\n}\n.vue-toggles .dot {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 9999px;\r\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\r\n  transition: margin ease 0.2s;\n}\n.vue-toggles .text {\r\n  position: absolute;\r\n  font-family: inherit;\r\n  user-select: none;\r\n  white-space: nowrap;\n}\n@media all and (-ms-high-contrast: none) {\n.vue-toggles .text {\r\n    /* IE11 fix */\r\n    top: 50%;\r\n    transform: translateY(-50%);\n}\n}\n@media (prefers-reduced-motion) {\r\n  /* disable animations if user have a reduced motion setting */\n.vue-toggles,\r\n  .vue-toggles *,\r\n  .vue-toggles *::before,\r\n  .vue-toggles *::after {\r\n    animation: none !important;\r\n    transition: none !important;\r\n    transition-duration: none !important;\n}\n}\r\n", map: {"version":3,"sources":["D:\\Folder\\codetemp\\vue-toggles\\src\\VueToggles.vue"],"names":[],"mappings":";AA2IA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yEAAA;AACA;AAEA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,2EAAA;EACA,4BAAA;AACA;AAEA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;AACA;AAEA;AACA;IACA,aAAA;IACA,QAAA;IACA,2BAAA;AACA;AACA;AAEA;EACA,6DAAA;AACA;;;;IAIA,0BAAA;IACA,2BAAA;IACA,oCAAA;AACA;AACA","file":"VueToggles.vue","sourcesContent":["<template>\r\n  <span\r\n    class=\"vue-toggles\"\r\n    :style=\"bgStyle\"\r\n    role=\"switch\"\r\n    tabindex=\"0\"\r\n    :aria-checked=\"value ? 'true' : 'false'\"\r\n    :aria-readonly=\"disabled ? 'true' : 'false'\"\r\n    @click=\"!disabled ? $emit('click', value) : null\"\r\n    @keyup.enter.prevent=\"!disabled ? $emit('click', value) : null\"\r\n    @keyup.space.prevent=\"!disabled ? $emit('click', value) : null\"\r\n  >\r\n    <span aria-hidden=\"true\" :style=\"dotStyle\" class=\"dot\">\r\n      <span v-show=\"checkedText && value\" :style=\"textStyle\" class=\"text\">\r\n        {{ checkedText }}\r\n      </span>\r\n\r\n      <span v-show=\"uncheckedText && !value\" :style=\"textStyle\" class=\"text\">\r\n        {{ uncheckedText }}\r\n      </span>\r\n    </span>\r\n  </span>\r\n</template>\r\n\r\n<script>\r\nexport default {\r\n  name: 'VueToggles',\r\n  props: {\r\n    value: {\r\n      type: Boolean,\r\n      default: false,\r\n    },\r\n    disabled: {\r\n      type: Boolean,\r\n      default: false,\r\n    },\r\n    reverse: {\r\n      type: Boolean,\r\n      default: false,\r\n    },\r\n    checkedText: {\r\n      type: String,\r\n      default: null,\r\n    },\r\n    uncheckedText: {\r\n      type: String,\r\n      default: null,\r\n    },\r\n    width: {\r\n      type: [Number, String],\r\n      default: 75,\r\n    },\r\n    height: {\r\n      type: [Number, String],\r\n      default: 25,\r\n    },\r\n    uncheckedBg: {\r\n      type: String,\r\n      default: '#939393',\r\n    },\r\n    checkedBg: {\r\n      type: String,\r\n      default: '#5850ec',\r\n    },\r\n    dotColor: {\r\n      type: String,\r\n      default: '#fff',\r\n    },\r\n    fontSize: {\r\n      type: [Number, String],\r\n      default: '12',\r\n    },\r\n    checkedColor: {\r\n      type: String,\r\n      default: '#fff',\r\n    },\r\n    uncheckedColor: {\r\n      type: String,\r\n      default: '#fff',\r\n    },\r\n    fontWeight: {\r\n      type: [Number, String],\r\n      default: 'normal',\r\n    },\r\n  },\r\n  computed: {\r\n    bgStyle() {\r\n      const styles = {\r\n        width: `${this.width}px`,\r\n        height: `${this.height}px`,\r\n        background: this.value ? this.checkedBg : this.uncheckedBg,\r\n        opacity: this.disabled ? '0.5' : '1',\r\n        cursor: !this.disabled ? 'pointer' : 'not-allowed',\r\n      };\r\n\r\n      return styles;\r\n    },\r\n    dotStyle() {\r\n      const styles = {\r\n        background: this.dotColor,\r\n        width: `${this.height - 8}px`,\r\n        height: `${this.height - 8}px`,\r\n        'min-width': `${this.height - 8}px`,\r\n        'min-height': `${this.height - 8}px`,\r\n        'margin-left': this.value ? `${this.width - (this.height - 3)}px` : '5px',\r\n      };\r\n\r\n      if ((!this.value && this.reverse) || (this.value && !this.reverse)) {\r\n        styles.marginLeft = `${this.width - (this.height - 3)}px`;\r\n      } else if ((this.value && this.reverse) || (!this.value && !this.reverse)) {\r\n        styles.marginLeft = '5px';\r\n      }\r\n\r\n      return styles;\r\n    },\r\n    textStyle() {\r\n      const styles = {\r\n        'font-weight': this.fontWeight,\r\n        'font-size': `${this.fontSize}px`,\r\n        color: this.value && !this.disabled ? this.checkedColor : this.uncheckedColor,\r\n        right: this.value ? `${this.height - 3}px` : 'auto',\r\n        left: this.value ? 'auto' : `${this.height - 3}px`,\r\n      };\r\n\r\n      if (!this.value && this.reverse) {\r\n        styles.right = `${this.height - 3}px`;\r\n        styles.left = 'auto';\r\n      } else if (this.value && this.reverse) {\r\n        styles.left = `${this.height - 3}px`;\r\n        styles.right = 'auto';\r\n      }\r\n\r\n      return styles;\r\n    },\r\n  },\r\n};\r\n</script>\r\n\r\n<style>\r\n.vue-toggles {\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 9999px;\r\n  overflow: hidden;\r\n  transition: background-color ease 0.2s, width ease 0.2s, height ease 0.2s;\r\n}\r\n\r\n.vue-toggles .dot {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 9999px;\r\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\r\n  transition: margin ease 0.2s;\r\n}\r\n\r\n.vue-toggles .text {\r\n  position: absolute;\r\n  font-family: inherit;\r\n  user-select: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n@media all and (-ms-high-contrast: none) {\r\n  .vue-toggles .text {\r\n    /* IE11 fix */\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion) {\r\n  /* disable animations if user have a reduced motion setting */\r\n  .vue-toggles,\r\n  .vue-toggles *,\r\n  .vue-toggles *::before,\r\n  .vue-toggles *::after {\r\n    animation: none !important;\r\n    transition: none !important;\r\n    transition-duration: none !important;\r\n  }\r\n}\r\n</style>\r\n"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

// Declare install function executed by Vue.use()
function install(Vue) {
  if (install.installed) { return; }
  install.installed = true;
  Vue.component('VueToggles', __vue_component__);
}

// Create module definition for Vue.use()
var plugin = {
  install: install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
var GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(122)))

/***/ }),

/***/ 1824:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return context; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal_vue__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_toggles__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(121);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var context = null;

/* harmony default export */ __webpack_exports__["b"] = ({
    props: {},
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_3__components_Modal_vue__["a" /* default */],
        VueToggles: __WEBPACK_IMPORTED_MODULE_5_vue_toggles__["a" /* default */]
    },
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["k" /* Sort */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["h" /* Page */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["f" /* Filter */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["l" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["j" /* Search */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["b" /* CommandColumn */]]
    },
    data: function data() {
        return {
            selectedRow: null,
            questions: [],
            selectedQuestion: null,

            toolbar: ['Search'],
            filterOptions: {
                type: 'Menu'
            },
            wrapSettings: { wrapMode: 'Content' },
            selectionOptions: { type: 'Single' },
            customAttributes: { class: 'customcss' },
            groupOptions: { columns: ['priorityText'] },
            mobileTemplate: function mobileTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_6_vue__["default"].component('mobileTemplate', {
                        template: '<div class="horizontal" style="justify-content: center;">\n                    <VueToggles @click="clicked" :value="data.sendToMobile" checkedBg="#0095b2" uncheckedBg="lightgrey"></VueToggles>\n                  </div>',
                        components: {
                            VueToggles: __WEBPACK_IMPORTED_MODULE_5_vue_toggles__["a" /* default */]
                        },
                        data: function data() {
                            return {
                                data: {}
                            };
                        },
                        methods: {
                            clicked: function clicked() {
                                this.data.sendToMobile = !this.data.sendToMobile;
                                context.updateSendToMobile(this.data.id, this.data.sendToMobile);
                            }
                        }
                    })
                };
            }
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.$store.dispatch('set_loading', true);
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["O" /* getAllAlarmTypesFaq */])();

                            case 3:
                                _this.questions = _context.sent;

                                _this.questions.forEach(function (el) {
                                    el.description = _this.$t(el.description);
                                });
                                _this.questions.forEach(function (el) {
                                    el.priorityText = [_this.$t('HIGH'), _this.$t('MID'), _this.$t('LOW')][el.priority - 1];
                                });
                                _this.questions = _this.questions.sort(function (a, b) {
                                    return a.priority - b.priority;
                                });
                                _this.$store.dispatch('set_loading', false);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        // rowClick(index) {
        //     if(this.selectedRow !== index) {
        //         this.selectedRow = index;
        //     } else {
        //         this.selectedRow = null;
        //     }
        // },
        rowClass: function rowClass(index) {
            return this.selectedRow === index ? 'selected py-4' : '';
        },

        toolbarClick: function toolbarClick(args) {
            switch (args.item.id) {}
        },
        dataBound: function dataBound() {
            this.$refs.grid.autoFitColumns();
        },
        rowSelected: function rowSelected(row) {
            if (row.target.tagName != "SPAN") {
                this.selectedRow = { rowindex: row.rowIndex, dataId: row.data.id };
            } else {
                this.$refs.grid.clearSelection();
            }
        },
        rowDeselected: function rowDeselected(row) {
            this.selectedRow = null;
            // this.selectedRow = row.
        },
        closeModal: function closeModal() {
            this.selectedRow = null;
            this.$refs.grid.clearSelection();
        },
        updateSendToMobile: function updateSendToMobile(id, value) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var index;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["_91" /* updateSendToMobileStatus */])(id, value);

                            case 2:
                                index = _this2.questions.findIndex(function (x) {
                                    return x.id == id;
                                });

                                _this2.questions[index].sendToMobile = value;

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            this.getData();

                            context = this;

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 2117:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2118);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1498)("a57006be", content, true, {});

/***/ }),

/***/ 2118:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1497)(true);
// imports


// module
exports.push([module.i, ".table[data-v-19d816d2]{border-top:none;border-left:none;border-right:none}.table tbody[data-v-19d816d2]{border-left:1px solid #a3d4e0;border-right:1px solid #a3d4e0}.e-grid .e-headercell.customcss[data-v-19d816d2]{padding:0 5px}.e-grid .e-headercell .e-headercelldiv[data-v-19d816d2]{padding-right:5px}.e-gridchkbox.customcss .e-checkbox-wrapper[data-v-19d816d2]{vertical-align:middle}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Faq.vue"],"names":[],"mappings":"AACA,wBACI,gBAAiB,AACjB,iBAAkB,AAClB,iBAAmB,CACtB,AACD,8BACI,8BAA+B,AAC/B,8BAAgC,CACnC,AACD,iDACI,aAAoB,CACvB,AACD,wDACI,iBAAkB,CACrB,AACD,6DACI,qBAAuB,CAC1B","file":"Faq.vue","sourcesContent":["\n.table[data-v-19d816d2] {\n    border-top: none;\n    border-left: none;\n    border-right: none;\n}\n.table tbody[data-v-19d816d2]{\n    border-left: 1px solid #A3D4E0;\n    border-right: 1px solid #A3D4E0;\n}\n.e-grid .e-headercell.customcss[data-v-19d816d2]{\n    padding:0 5px 0 5px;\n}\n.e-grid .e-headercell .e-headercelldiv[data-v-19d816d2]{\n    padding-right:5px;\n}\n.e-gridchkbox.customcss .e-checkbox-wrapper[data-v-19d816d2]{\n    vertical-align: middle;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('modal',{attrs:{"showDialog":_vm.selectedRow != null,"maxWidth":'50vw',"title":_vm.selectedRow!= null ? _vm.questions.find(function (x) { return x.id == _vm.selectedRow.dataId; }).description : null},on:{"close":_vm.closeModal}},[_c('div',{staticClass:"m-4"},[_c('div',{staticClass:"mb-1",staticStyle:{"font-weight":"bold"}},[_vm._v("\n         "+_vm._s(_vm.selectedRow != null ? _vm.questions.find(function (x) { return x.id == _vm.selectedRow.dataId; }).description : null)+"\n      ")]),_vm._v(" "),_c('div',{staticStyle:{"white-space":"pre-line"}},[_vm._v("\n        "+_vm._s(_vm.selectedRow != null ? _vm.questions.find(function (x) { return x.id == _vm.selectedRow.dataId; }).conditions : null)+"\n      ")])])]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"100%","overflow-x":"auto"}},[_c('div',{staticClass:"max-grid"},[_c('ejs-grid',{ref:"grid",attrs:{"height":"100%","width":"100%","toolbar":_vm.toolbar,"rowSelected":_vm.rowSelected,"rowDeselected":_vm.rowDeselected,"selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.questions,"allowPaging":false,"allowFiltering":false,"allowSorting":true,"allowMultiSorting":true,"showBusyIndicator":true,"allowGrouping":true,"groupSettings":_vm.groupOptions}},[_c('e-columns',[_c('e-column',{attrs:{"field":"id","headerText":_vm.$t('NUMBER'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"description","headerText":_vm.$t('DESCRIPTION'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),(_vm.$store.getters.isAdmin)?_c('e-column',{attrs:{"field":"sendToMobile","headerText":_vm.$t('SEND_TO_MOBILE'),"template":_vm.mobileTemplate,"allowFiltering":false,"allowSorting":false,"textAlign":"Center"}}):_vm._e(),_vm._v(" "),_c('e-column',{attrs:{"visible":false,"field":"priorityText","headerText":_vm.$t('PRIORITY'),"textAlign":"Left","customAttributes":_vm.customAttributes}})],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/29.fc44376ddd43ec50be44.js